import React from 'react'
import View from './view'

const Address = ({address}) => {
  const {
    attributes
  } = address

  return (
    <div className="details-card">
      <h2>Address</h2>
      <View {...attributes}/>
    </div>
  )
}

export default Address


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/views/address/index.jsx